import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service'
import { Router, ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  isUserLogin: boolean
  websites: Object
  photos: Object
  messages: Object
  users: Object
  public errorMsg: any

  constructor(
    private userApi: ApiService,
    private router:Router,
    private route: ActivatedRoute) {       
      const newLocal = this.isUserLogin = this.userApi.isLoggedIn();
    }

  ngOnInit(): void {

    this.userApi.getWebsites('all',8).subscribe(
      data => {
        this.websites = data;
        // console.log(this.websites);
      },
      error => this.errorMsg = error      
    );

    this.userApi.getPhotos('all',8).subscribe(
      data => {
        this.photos = data;
        // console.log(this.photos);
      },
      error => this.errorMsg = error      
    );

    this.userApi.getMessage(8).subscribe(
      data => {
        this.messages = data;
      },
      error => this.errorMsg = error      
    );

    this.userApi.getUsers(8).subscribe(
      data => {
        this.users = data;
      },
      error => this.errorMsg = error      
    );
  }

  onSelect(item) {
    this.router.navigate(['../../web', item.url, {type: item.item_category, postType: 'websites'}]); // Absolute url
    // this.router.navigate(['/web/'+ item.url, {type: item.item_category}], {relativeTo: this.route}); // relative url
  }

  onSelectPotography(item) {
    this.router.navigate(['../../photography', item.url, {type: item.item_category, postType: 'photography'}]); // Absolute url
    // this.router.navigate(['/photography/'+ item.url, {type: item.item_category}], {relativeTo: this.route}); // relative url
  }

  goWeb() {
    this.router.navigate(['/user/dashboard/web'], {relativeTo: this.route});
  }

  goPhotogrphy() {
    this.router.navigate(['/user/dashboard/photography'], {relativeTo: this.route});
  }

  goMessage() {
    this.router.navigate(['/user/dashboard/message'], {relativeTo: this.route});
  }

  goUser() {
    this.router.navigate(['/user/dashboard/user'], {relativeTo: this.route});
  }

}
